import clx from "classnames";
import { UIPick } from "models/Models";
import { ChangeEvent } from "react";
import { teamMap } from "services/TeamMap";
import "./TeamPick.scss";

interface Props {
  pick: UIPick;
  prefix: string;
  onGamesChanged: (pick: UIPick, games: number) => void;
  onTeamSelected: (pick: UIPick, teamId: number) => void;
}

export const TeamPick = (props: Props) => {
  const onGamesChanged = (event: ChangeEvent<HTMLSelectElement>): void => {
    props.onGamesChanged(props.pick, +event.target.value);
  };

  const teamSelected = (teamId: number) => {
    if (!props.pick.isOpen) {
      return;
    }
    props.onTeamSelected(props.pick, teamId);
  };

  return (
    <div
      className={clx({ "is-open": props.pick.isOpen, "is-picked": props.pick.teamId === props.pick[`${props.prefix}TeamId`] }, "team-container")}
      onClick={() => teamSelected(props.pick[`${props.prefix}TeamId`])}
    >
      <div
        className={clx(
          {
            isPicked: props.pick.teamId === props.pick[`${props.prefix}TeamId`] && !props.pick.isOpen,
            correctPick: props.pick.teamId === props.pick.winningTeamId,
            wrongPick: props.pick.winningTeamId && props.pick.teamId !== props.pick.winningTeamId,
          },
          "pick-indicator"
        )}
      >
        <span className="total-games">
          {/* <input className="teamRadio" type="radio" value={props.pick[`${props.prefix}TeamId`]} name={`seriesPick${props.pick.seriesId}`} disabled={!props.pick.isOpen} /> */}
          {props.pick.games}
        </span>
      </div>
      <svg className="team-logo">
        <use xlinkHref={"/teams-dark.svg#team-" + teamMap[props.pick[`${props.prefix}TeamShortName`]] + "-dark"}></use>
      </svg>
      <span className="teamName">{props.pick[`${props.prefix}TeamName`]}</span>
      <span className="teamName short">{props.pick[`${props.prefix}TeamShortName`]}</span>
      {props.pick.isOpen && (
        <select
          disabled={!props.pick.isOpen}
          onChange={onGamesChanged}
          value={props.pick.games || "0"}
          name={`seriesGames${props.pick.seriesId}`}
          className={clx("games", { noValue: !props.pick.games, hidden: props.pick.teamId !== props.pick[`${props.prefix}TeamId`] })}
        >
          <option value="0" disabled>
            --
          </option>
          {[4, 5, 6, 7].map((m) => (
            <option value={m} key={m}>
              {m}
            </option>
          ))}
        </select>
      )}
      {!props.pick.isOpen && <span className="games">{props.pick[`${props.prefix}TeamWins`]}</span>}
    </div>
  );
};
